import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-498a6a50"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "packet-page common-page"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "page-title"
}, "分组管理", -1));
const _hoisted_3 = {
  class: "packet-content flex"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "add-top-text"
}, "添加分组", -1));
const _hoisted_5 = {
  class: "top-list"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "iconfont yiqiyong-renqun text"
})], -1));
const _hoisted_8 = {
  class: "role-item-name text"
};
const _hoisted_9 = {
  class: "role-item-more"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = ["onClick"];
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont yiqiyong-gengduo"
}, null, -1));
const _hoisted_13 = {
  class: "second-header flex"
};
const _hoisted_14 = {
  class: "title"
};
const _hoisted_15 = {
  class: "second-category-list"
};
const _hoisted_16 = {
  class: "second-item flex"
};
const _hoisted_17 = {
  class: "name"
};
const _hoisted_18 = {
  class: "second-control"
};
import { getSourceGroupApi } from '@/service/modules/user';
import { ref, onMounted, markRaw } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getPageSize, getoffset } from '@/utils/math';
import noData from '@/components/no-data.vue';
import topCategoryDialog from './components/packet/top-category-dialog.vue';
import secondCategoryDialog from './components/packet/second-category-dialog.vue';
import { QuestionFilled } from '@element-plus/icons-vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { deleteCategoryApi } from '@/service/modules/sale';
export default /*#__PURE__*/_defineComponent({
  __name: 'packet',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const sourceGroupList = ref([]);
    const topActiveIndex = ref(0);
    const topCategoryActiveData = ref({});
    const scrollHeight = ref(0);
    const topCategoryDialogVisible = ref(false);
    const topCategoryDialogType = ref('add');
    const topCategoryDialogData = ref({});
    const secondCategoryDialogVisible = ref(false);
    const secondCategoryDialogType = ref('add');
    const secondCategoryDialogData = ref({});
    getSourceGroup();
    async function getSourceGroup() {
      try {
        let res = await getSourceGroupApi();
        sourceGroupList.value = res.data;
        topCategoryActiveData.value = sourceGroupList.value[topActiveIndex.value] ?? {};
      } catch {}
    }
    /**
     * 一级分类
    */
    function handleTopCategorySelect(item, index) {
      topCategoryActiveData.value = item;
      topActiveIndex.value = index;
    }
    function handleTopCategoryDialog(type, item) {
      topCategoryDialogType.value = type;
      if (item) topCategoryDialogData.value = item;
      topCategoryDialogVisible.value = true;
    }
    function handleCloseTopCategoryDialog() {
      topCategoryDialogVisible.value = false;
      topCategoryDialogData.value = {};
      topCategoryDialogType.value = 'add';
    }
    function handleDeleteTopCategory(id, index) {
      console.log('index', index, topActiveIndex.value);
      ElMessageBox.confirm('此操作将永久删除该数据, 是否继续？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        icon: markRaw(QuestionFilled)
      }).then(async () => {
        try {
          if (index === topActiveIndex.value) topActiveIndex.value = 0;
          await deleteCategoryApi(id);
          ElMessage.success('删除成功');
          getSourceGroup();
        } catch {}
      }).catch(() => {});
    }
    /**
     * 二级分类
    */
    function handleSecondCategoryDialog(type, item) {
      secondCategoryDialogType.value = type;
      if (item) secondCategoryDialogData.value = item;
      secondCategoryDialogVisible.value = true;
    }
    function handleCloseSecondCategoryDialog() {
      secondCategoryDialogData.value = {};
      secondCategoryDialogType.value = 'add';
      secondCategoryDialogVisible.value = false;
    }
    function handleDeleteSecondCategory(id) {
      let params = {
        id
      };
      ElMessageBox.confirm('此操作将永久删除该数据, 是否继续？', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        icon: markRaw(QuestionFilled)
      }).then(async () => {
        try {
          await deleteCategoryApi(id);
          ElMessage.success('删除成功');
          getSourceGroup();
        } catch {}
      }).catch(() => {});
    }
    onMounted(() => {
      let pageArea = getPageSize();
      let offsetArea = getoffset('.packet-content');
      scrollHeight.value = pageArea.height - offsetArea.top - 20;
    });
    return (_ctx, _cache) => {
      const _component_Plus = _resolveComponent("Plus");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_popover = _resolveComponent("el-popover");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_link = _resolveComponent("el-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: "top-category",
        style: _normalizeStyle({
          height: `${scrollHeight.value}px`
        })
      }, [_createElementVNode("div", {
        class: "add-top flex-center",
        onClick: _cache[0] || (_cache[0] = $event => handleTopCategoryDialog('add'))
      }, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_Plus)]),
        _: 1
      }), _hoisted_4]), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sourceGroupList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["top-item", {
            active: topActiveIndex.value === index
          }]),
          key: index,
          onClick: $event => handleTopCategorySelect(item, index)
        }, [_hoisted_7, _createElementVNode("div", _hoisted_8, _toDisplayString(item?.name), 1), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_popover, {
          "show-arrow": false,
          placement: "bottom-start",
          trigger: "hover",
          width: "50"
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "role-btn-edit",
            onClick: _withModifiers($event => handleTopCategoryDialog('edit', item), ["stop"])
          }, "编辑分组", 8, _hoisted_10), _createElementVNode("div", {
            class: "role-btn-del",
            onClick: _withModifiers($event => handleDeleteTopCategory(item.id, index), ["stop"])
          }, "删除", 8, _hoisted_11)]),
          reference: _withCtx(() => [_hoisted_12]),
          _: 2
        }, 1024)])], 10, _hoisted_6);
      }), 128))])], 4), _createElementVNode("div", {
        class: "second-category",
        style: _normalizeStyle({
          height: `${scrollHeight.value}px`
        })
      }, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(topCategoryActiveData.value?.name), 1), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[1] || (_cache[1] = $event => handleSecondCategoryDialog('add'))
      }, {
        default: _withCtx(() => [_createTextVNode("添加二级分组")]),
        _: 1
      })]), _createElementVNode("div", _hoisted_15, [topCategoryActiveData.value?.children && topCategoryActiveData.value?.children.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(topCategoryActiveData.value.children, item => {
        return _openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(item?.name), 1), _createElementVNode("div", _hoisted_18, [_createVNode(_component_el_link, {
          type: "primary",
          style: {
            "margin-right": "10px"
          },
          onClick: $event => handleSecondCategoryDialog('edit', item)
        }, {
          default: _withCtx(() => [_createTextVNode("编辑")]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_link, {
          type: "danger",
          onClick: $event => handleDeleteSecondCategory(item.id)
        }, {
          default: _withCtx(() => [_createTextVNode("删除")]),
          _: 2
        }, 1032, ["onClick"])])]);
      }), 256)) : (_openBlock(), _createBlock(noData, {
        key: 1
      }))])], 4)]), _createVNode(topCategoryDialog, {
        "dialog-visible": topCategoryDialogVisible.value,
        "dialog-type": topCategoryDialogType.value,
        "item-data": topCategoryDialogData.value,
        onCloseDialog: handleCloseTopCategoryDialog,
        onRestData: getSourceGroup
      }, null, 8, ["dialog-visible", "dialog-type", "item-data"]), _createVNode(secondCategoryDialog, {
        "dialog-visible": secondCategoryDialogVisible.value,
        "dialog-type": secondCategoryDialogType.value,
        "item-data": secondCategoryDialogData.value,
        "parent-list": sourceGroupList.value,
        "parent-id": topCategoryActiveData.value.id,
        onCloseDialog: handleCloseSecondCategoryDialog,
        onRestData: getSourceGroup
      }, null, 8, ["dialog-visible", "dialog-type", "item-data", "parent-list", "parent-id"])]);
    };
  }
});